/**
 * Extract an in-app route path from a deep link or universal link URL.
 */
export function parseDeepLinkPath(url) {
  if (!url) return null

  try {
    const parsed = new URL(url)
    const isHttp = parsed.protocol === 'http:' || parsed.protocol === 'https:'
    let path

    if (!isHttp) {
      // Custom scheme e.g. com.onlygulp10500://resto/order_status/1
      const hostPart = parsed.hostname ? `/${parsed.hostname}` : ''
      path = `${hostPart}${parsed.pathname || ''}` || '/'
    } else {
      path = parsed.pathname || '/'
      const basePath = import.meta.env.VITE_BASE_PATH || ''
      if (basePath && path.startsWith(basePath)) {
        path = path.slice(basePath.length) || '/'
      }
    }

    if (parsed.search) path += parsed.search
    if (parsed.hash) path += parsed.hash

    return path.startsWith('/') ? path : `/${path}`
  } catch {
    const schemeMatch = url.match(/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/\/?(.*)$/)
    if (schemeMatch?.[1]) {
      const path = schemeMatch[1].startsWith('/') ? schemeMatch[1] : `/${schemeMatch[1]}`
      return path
    }
    return url.startsWith('/') ? url : `/${url}`
  }
}
